module.exports = __webpack_public_path__ + "media/images/emblems/Bonvillars-coat_of_arms-8c6617254a84cff6c38795df90a385ce.svg";